import React, { ReactNode, forwardRef } from 'react';
import AirGarageLogo from 'assets/AirGarage.svg?react';
import styles from './PDFReportPreview.module.css';

type PDFPageProps = {
    spotAddress: string;
    dateTime: string;
    title?: string;
    filters?: { label: string; value: string }[];
    children: ReactNode;
};

const PDFPage = forwardRef<HTMLDivElement, PDFPageProps>(function PDFPage(
    { spotAddress, dateTime, title, filters = [], children },
    ref
) {
    return (
        <div className={styles.pdfPage} ref={ref}>
            <div className={styles.pageHeader}>
                <AirGarageLogo className={styles.logo} />
                <div className={styles.headerInfo}>
                    <p className={styles.spotAddress}>Revenue insights for {spotAddress}</p>
                    <p className={styles.dateTime}>Downloaded at {dateTime}</p>
                </div>
            </div>

            <div className={styles.pageContent}>
                <>
                    <div className={styles.pageTitleContainer}>
                        {title && <h2 className={styles.pageTitle}>{title}</h2>}
                        {filters.map((filter) => (
                            <p className={styles.filterInfo} key={filter.label}>
                                <b>{filter.label ? `${filter.label}:` : ''}</b> {filter.value}
                            </p>
                        ))}
                    </div>
                    {children}
                </>
            </div>

            <div className={styles.pageFooter} />
        </div>
    );
});

export default PDFPage;
